<template>
  <div>
    <Nav></Nav>
    <div class="content">
      <div class="title">编辑指数符号</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">id</span>
          <input type="text" v-model="List.id" disabled/>
          <span class="xing">* 不可修改</span>
        </div>
          <div class="form_item">
          <span class="item_name">switchboardId</span>
          <input type="text" v-model="List.switchboardId" disabled/>
          <span class="xing">* 不可修改</span>
        </div>
        <div class="form_item">
          <span class="item_name">sign</span>
          <input type="text" v-model="List.sign" />
        </div>
      </div>
    </div>

    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="updateCalcSign">保存</el-button>
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      List:[]
    };
  },
  created() {
    this.getRoleList();
  },
  mounted() {},
  methods: {
    getRoleList() {
      let _this = this;
     http.get(apiData.calcSignShow, true, {id:_this.$route.query.id}, (res) => {
          if(res.data.code == 200){
          _this.List = res.data.data;

          }else{
             _this.$message.error(res.data.msg);
          }
        });
     
      
    },
    updateCalcSign(){
      let _this = this;
       let params = _this.List
      // console.log("参数", params);
      http.put(apiData.calcSignUpdate, true, params, (res) => {
        if (res.data.code == 200) {
           this.$router.push('/company/calcSign');
        } else {
          
        }
      });
    },
    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 400px;
        height: 30px;
        margin-top: 5px;
        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}

.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  border: 1px solid #55c4b8;

  color: #fff;
}
</style>
